<template>
  <div id="app">
    <VideoPlay></VideoPlay>
    <Suspension></Suspension>
    <Header></Header>
    <router-view/>
    <Footer></Footer>
  </div>
</template>

<script>
import '@/util/public'
export default {
  name: 'App',
}
</script>



// WEBPACK FOOTER //
// src/App.vue